/* eslint-disable react/display-name */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import { Box, Flex, Text } from '@chakra-ui/core';
import React, { memo } from 'react';
import { FaCheck } from 'react-icons/fa';
import { ShiftSlotViewModel } from '../../utils/RequisitionDetailsViewModel';
import { MismatchBadge } from '../components/MismatchBadge';
import { EmptyPlaceholder } from '../components/TableComponents';
import colors from '../../../../../../styles/colors';

interface TimeCellProps extends ShiftSlotViewModel {
  align?: 'left' | 'right' | 'center';
  colSpan?: number;
}

export const TimeCell = memo(({ timeLabel, isRequired, exists, isMismatch, align = 'left' }: TimeCellProps) => {
  return (
    <Box textAlign={align} data-testid="time-cell">
      {exists && timeLabel ? (
        <Flex align="center" justify="space-between" display="inline-flex" width="100%" gridGap="4px">
          <Flex align="center" gridGap="4px">
            <Text fontSize="13px" mr={1} data-testid="time-cell-label">
              {timeLabel}
            </Text>
            {isRequired && (
              <Box display="inline-flex" ml={2} data-testid="time-cell-check">
                <FaCheck size={11} color={colors.gray[450]} />
              </Box>
            )}
          </Flex>
          {isMismatch && <MismatchBadge data-testid="time-cell-mismatch" />}
        </Flex>
      ) : (
        <Box data-testid="time-cell-empty">
          <EmptyPlaceholder />
        </Box>
      )}
    </Box>
  );
});

TimeCell.displayName = 'TimeCell';
